import { Component, OnInit, } from '@angular/core';
import { NavParams, PopoverController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-notification-box',
  templateUrl: './notification-box.component.html',
  styleUrls: ['./notification-box.component.scss'],
})
export class NotificationBoxComponent implements OnInit {
  mobile: boolean = false;
  //todo  obtener de api
  newNotificationList =  [ 
        {name: "user1", detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", time: "Hace 14 min"},
        {detail: "only detail Lorem Ipsum is simply dummy text of the printing and typesetting industry.", time: "Hace 14 min"},
  ] 
  previousNotificationList = [ 
        {name: "user2", detail: "Lorem Ipsum Pellentesque faucibus pretium, convallis ipsum", time: "Hace 14 min"},
        {name: "user3", detail: "Lorem Ipsum Pellentesque faucibusPellentesque faucibus Pellentesque faucibus", time: "Hace 14 min"}
  ] 

  constructor(public popoverController: PopoverController, public platform: Platform,) { }

  ngOnInit() {
    if ((this.platform.is("mobileweb") && document.documentElement.clientWidth <= 768 ) || this.platform.is("mobile")) this.mobile = true;
   // this.newNotificationList = this.navParams.get('newNotificationList');
   // this.previousNotificationList = this.navParams.get('previousNotificationList');
  }

  async onSelectNotification(selectedValue: any) {
    console.log(selectedValue)
    //await this.popoverController.dismiss({ selectedValue });
   }
}
